import { Component, Input, OnInit } from '@angular/core';
import { IVestaMessage } from '../../interfaces';

@Component({
    selector: 'app-vesta-info',
    templateUrl: './vesta-info.component.html',
    styleUrls: ['./vesta-info.component.scss']
})
export class VestaInfoComponent implements OnInit {
    @Input() message: IVestaMessage | null | undefined;
    @Input() success: boolean = false;

    constructor() {
    }

    ngOnInit() {
    }

    close() {
        this.message = null;
    }
}
